<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      
          <v-btn  
            :dark='dark'              
            v-bind="attrs"
            v-on="on"
            icon
          >
            <v-icon>mdi-microphone-plus</v-icon>
          </v-btn>
          <span style="color:rgb(102,102,102)">{{buttonLabel}}</span>
    </template>

    <v-list dense>
      <v-list-item-subtitle>Microphone</v-list-item-subtitle>
      <v-list-item
        v-for="(microphone, i) in microphones"
        :key="i"
        v-bind:disabled="!allowMicrophoneChange"
        v-on:click="setMicrophone(microphone)"
      >
        <v-list-item-icon>
          <v-icon v-if="(microphone.deviceId == microphoneId)">mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ microphone.label }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <v-list dense>
      <v-list-item-subtitle>Speaker</v-list-item-subtitle>
      <v-list-item
        v-for="(speaker, i) in speakers"
        :key="i"
        v-on:click="speakerId = speaker.deviceId"
      >
        <v-list-item-icon>
          <v-icon v-if="speaker.deviceId == speakerId">mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ speaker.label }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
    
    <v-list dense>
      <v-list-item-subtitle>Camera</v-list-item-subtitle>
      <v-list-item
        v-for="(camera, i) in cameras"
        :key="i"
        v-on:click="cameraId = camera.deviceId"
      >
        <v-list-item-icon>
          <v-icon v-if="camera.deviceId == cameraId">mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ camera.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script >
export default {
  data: function () {
    return {
      microphones: [],
      speakers: [],
      cameras: [],
      toggle_exclusive: undefined,
      

    }
  },
  props: ['session', 'buttonLabel', 'dark'],
  computed: {
    microphoneId: {
      get() {
        console.log('m-i-s: getting microphone', this.$store.state.microphoneId);
        return this.$store.state.microphoneId;
      },
      set: function (v) {
        this.$store.dispatch("setMicrophoneId", v);
      },
    },
    speakerId: {
      get() {
        return this.$store.state.speakerId;
      },
      set: function (v) {
        this.$store.dispatch("setSpeakerId", v);
      },
    },
    cameraId: {
      get() {
        return this.$store.state.cameraId;
      },
      set: function (v) {
        this.$store.dispatch("setCameraId", v);
      },
    },
    allowMicrophoneChange: function () {
      if (!this.session) {
        return true;
      }
      if (this.session) {
        // you would think I wouldn't need this, but I do!
        if (this.session.state) {
          console.log(this.session.state);
          if (this.session.state == "Established") {
            return true;
          }
        }
      }
    },
  },
  methods: {
    setMicrophone(microphone) {
      if (this.allowMicrophoneChange) {
        this.microphoneId = microphone.deviceId;
      }
    },
    async refreshAvailableInputs() {
      let mediaDeviceInfos = await window.navigator.mediaDevices.enumerateDevices();
      let microphones = [ { label: 'Default', deviceId: 'default' }];
      let speakers = [ { label: 'Default', deviceId: null }];
      let cameras = [ { label: 'None', deviceId: false }];
      console.log(mediaDeviceInfos);

      for (let i = 0; i < mediaDeviceInfos.length; i++) {
        let mdi = mediaDeviceInfos[i];
        if (mdi.deviceId == "default" || mdi.deviceId == "communications") {
          continue;
        }
        if (mdi.kind == "audioinput") {
          microphones.push({ label: mdi.label, deviceId: mdi.deviceId });
        } else if (mdi.kind == "audiooutput") {
          speakers.push({ label: mdi.label, deviceId: mdi.deviceId });
        } else if (mdi.kind == "videoinput") {
          if (mdi.label) {
            cameras.push({ label: mdi.label, deviceId: mdi.deviceId });
          } else {
            cameras.push({ label: "Default Camera", deviceId: "default" });
          }
        }
      }
      
      this.microphones = microphones;
      this.speakers = speakers;
      this.cameras = cameras;
    },
  },
  async mounted() {
    this.refreshAvailableInputs();
  },
  watch: {
    // refreshAvailableInputs doesn't monitor any vue variables that
    // are reactive. So when the microphoneId chnges, refresh the selection
    // list. This works to populate the list right after permission is granted
    // to the microphone the first time.
    microphoneId: function () {
      this.refreshAvailableInputs();
    },
  },
};
</script>
